import React from 'react';
import '../less/index.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../auxiliary-components/shared/HeroBlock';
import Tabs from '../../../../auxiliary-components/shared/Tabs';
import Tariffs from '../../../../auxiliary-components/shared/TariffsBlock';
import CalculatorNew from '../../../../auxiliary-components/CalculatorNew';
import { vygodaCardTerms } from "../../../../services/urls/urls";
import AdditionalProduct from '../../../../auxiliary-components/shared/AdditionalProductBlock';
import FilesForDownloadNew from "../../../../auxiliary-components/shared/FilesForDownloadNew";
import TextAboveFooterNew from "../../../../auxiliary-components/shared/TextAboveFooterNew";
import QuestionsAdminNew from '../../../../auxiliary-components/shared/QuestionsAdminNew';
import FAQStorybook from '@abank/abank-faq';
import CardOrderModal from '../../../../auxiliary-components/CardOrderModal';
import { Preloader } from 'MWComponents';
import { canUseDOM } from '../../../../helpers/canUseDOM';
import AdvantagesAdmin from '../../../../auxiliary-components/shared/AdvantagesBlockAdmin';
import additionalCards from '../enums/additional_cards_data.json';
import tariffs_data from '../enums/tariffs_data.json';
import hero_data from '../enums/hero_data.json';
import { filterByEnvironment } from '../../../../helpers/utils/environmentFilter';
import { howToGetCardItems } from '../../enums/howToGetCardData';
import HowToBlockNew from '../../../../auxiliary-components/shared/HowToBlockNew';

export default function template() {
  const model = this.getModel();
  const page = 'vygoda-card-new';

  const tabs = [{tab: 'tariffs', title: 'VYGODA_CARD_NEW_TABS_TITLE_01'},
          {tab: 'calculator', title: 'VYGODA_CARD_NEW_TABS_TITLE_02'},
          {tab: 'how-to-get-card', title: 'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TAB_TITLE'}];

  const handlersMap = {
    scrollToFaq: this.scrollToFrequentlyAskedQuestions,
    toggleHeroModal: this.toggleModal,
  };

  const tariffsData = tariffs_data.map(item => {
    if (typeof item.label === 'object' && item.label.link && item.label.link.onClick) {
      return {
        ...item,
        label: {
          ...item.label,
          link: {
            ...item.label.link,
            onClick: handlersMap[item.label.link.onClick],
          },
        },
      };
    }

    return item;
  });

  const heroData = {
    ...hero_data,
    link: {
      ...hero_data.link,
      onClick: handlersMap[hero_data.link.onClick],
    },
  };

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  return (
    <div className="module-profit-new">
      <Hero
        data={heroData}
        img={hero_img}
        page={page}
      />
      <div className="content">
        {!this.state.faqTab ? (
          <>
            <AdvantagesAdmin
              data={this.widgetsHelper.getWidget.call(this, 'green_text_block')}
              loader={this.state.loader}
            />
            <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} page={page}>
              <Tariffs
                items={tariffsData}
                title={'VYGODA_CARD_NEW_CARDS_TARIFFS_TITLE'}
                btnLink={vygodaCardTerms}
                btnText={'VYGODA_CARD_NEW_CARDS_TARIFFS_BTN'}
                page={page}
                text={'VYGODA_CARD_NEW_CARDS_TARIFFS_TEXT'}
              />
              {model.creditSum ? (
                <CalculatorNew model={model} type="credit_cards" {...this.props}/>
              ) : (canUseDOM ? <Preloader /> : null)}
              <HowToBlockNew
                title={'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TITLE'}
                items={howToGetCardItems}
              />
            </Tabs>
            <AdditionalProduct
              items={additionalCards}
              title={'VYGODA_CARD_NEW_ADDITIONAL_PRODUCT_TITLE'}
              page={page}
            />
            <QuestionsAdminNew
              page={page}
              widget={questionsWidget}
              toggleFaqTab={this.toggleFaqTab}
              title={'FAQ_SHORT_NEW_TITLE'}
            />
            <FilesForDownloadNew
              lang={this.props.lang}
              widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
            />
            <TextAboveFooterNew
              widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
            />
          </>
        ) : (
        <FAQStorybook
          widget={questionsWidget}
          title={this.l10n('VYGODA_CARD_NEW_FAQ_STORYBOOK_TITLE')}
          btnText={this.l10n('VYGODA_CARD_NEW_FAQ_STORYBOOK_BTN_TEXT')}
          onBtnClick={this.toggleFaqTab}
          filterByEnvironment={filterByEnvironment}
        />
        )}
      </div>
      {this.state.showModal ?
        <CardOrderModal closeModal={this.toggleModal} product={"vygoda"} isOpen={this.state.showModal}/> : ''
      }
    </div>
  );
}
